import { View } from 'backbone.marionette';
import copy from 'copy-to-clipboard';

import { User } from '../../../models';

import Preloader from '../../../utils/Preloader';
import ErrorsModal from '../../../utils/ErrorsModal';
import { rerender } from '../../../utils';

/**
 * @desc Core League Invites View Class
 */
export default class CoreLeagueInvitesView extends View {

	get template() {
		throw new Error( "Need set template for child CoreLeagueInvitesView class" );
	}

	get className() {
		return "league-invites-page shadow";
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			'invite_form':          '.js-league-invite-form',
			'copy_league_code':     '.js-copy-league-code',
			'league_code':          '.js-league-code',
			'switch_form':          '.js-switch-form',
			'step':                 '.js-step',
			'add_more_email_field': '.js-add-more-email-field',
			'email_fields':         '.js-email-fields',
			'invite_email':         '.js-invite-by-email',
			'invite_link':          '.js-invite-link',
			'copy_link':            '.js-copy-link',
			'sharing':              '.js-sharing',
			'send_email_invites':   '.js-send-email-invites',
			'copied_code':          '.js-copied-code'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'click @ui.add_more_email_field': 'moreEmail',
			'click @ui.switch_form':          'switchForm',
			'click @ui.copy_league_code':     'copyCode',
			'click @ui.copy_link':            'copyLink',
			'click @ui.sharing':              'sharing',
			'click @ui.send_email_invites':   'sendEmailInvites'
		};
	}

	/**
	 * Set model events
	 * @returns object
	 */

	modelEvents() {
		return {
			'league:invites:errors':  'sendInvitesError',
			'league:invites:success': 'sendInvitesSuccess',
			'league:query:not:found': 'redirectToMyLeague',
		};
	}

	/**
	 *    Initialize view data
	 */
	async initialize() {

		this.league_id = this.getOption( 'league_id' );
		this.share     = this.getOption( 'share' );

		this.model.set( {
			sms_text:        '',
			invite_link:     '',
			is_after_create: this.getOption( 'is_after_create' )
		} );

		Preloader.show();
		await this.fetchData();
		this.updateModel()
			.updateView();
		Preloader.hide();
	}

	/**
	 *
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		return this.model.setShowUrl().fetch(
			{
				data: {
					'id': this.league_id
				}
			}
		);
	}

	updateModel() {
		this.checkCurrentUser();

		let code = this.model.get( 'code' ),
			league_name = this.model.get( 'name' ),
			team_name = User.get( 'team_name' ),
			invite_link = this.getIviteLink();

		this.share.set( {
			code, league_name, invite_link
		} );

		this.model.set( {
			sms_text:    `I entered my team ${team_name} in ${league_name} in NRL Fantasy. Take the challenge and join my league now!` + ` ${invite_link}`,
			invite_link: invite_link
		} );

		return this;
	}

	checkCurrentUser() {
		if( !this.model
			.checkLeagueMember()
		) {
			this.redirectToMyLeague();
		}
	}

	getIviteLink() {
		let code = this.model.get( 'code' );
		return `https:${process.env.ABSPATH}fantasy/league/join?code=${code}`;
	}

	updateView() {
		this.render();
	}

	copyCode() {
		let code = this.getUI( 'league_code' ).val();
		copy( code );

		this.getUI( 'copied_code' ).removeClass( 'hidden' );
	}

	switchForm() {
		this.getUI( 'step' ).toggleClass( 'hidden' );
	}

	copyLink() {
		let invite_link = this.getUI( 'invite_link' ).find( 'input' ).val();
		copy( invite_link );

		this.getUI( 'invite_link' ).removeClass( 'hidden' );
	}

	moreEmail() {
		let new_element = this.getUI( 'email_fields' ).find( '.form-part:last' ).clone();

		new_element.find( 'input' ).val( '' );
		this.getUI( 'email_fields' ).append( new_element );
	}

	sharing( element ) {
		console.log("triggered")
		let data = {
			sc:      $( element.currentTarget ).data( 'type' ),
			user_id:   User.id,
			league_id: this.league_id
		};

		this.share.share( data );
	}

	/**
	 *
	 * @returns {Array}
	 */
	get emailLists() {
		let email_fields = [];

		this.getUI( 'invite_email' ).each( ( key, element ) => {
			if ( $( element ).val() !== '' ) {
				let item = {
					'email': $( element ).val()
				};
				email_fields.push( item );
			}
		} );

		return email_fields;
	}

	sendEmailInvites() {
		let data = {
			league_id: this.model.get( 'id' ),
			invites:   this.emailLists
		};

		this.model.sendInvites( data );
	}

	sendInvitesError( errors ) {
		Preloader.hide();
		ErrorsModal.show( errors );
	}

	sendInvitesSuccess() {
		alert( 'Email Invitations have been sent' );

		this.getUI( 'invite_form' ).trigger( 'reset' );
	}

	redirectToMyLeague() {
		rerender();
		// let data = {
		// 	league_id: this.model.get( 'id' )}
		// redirectTo(`/fantasy/league/${data.league_id}/manage`);
	}
}